// React
import React, { useState, useRef, useEffect } from "react";

import { Modal, Button } from "react-bootstrap";

// Style
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

// AWS
import { API, Auth } from "aws-amplify";

// Google Auth
import { GoogleLogout } from "react-google-login";

// Local Storage
import ls from "local-storage";

// UUID
const uuidv4 = require("uuid/v4");

export default function AccountModal(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [currentOrganizationId, setCurrentOrganizationId] = useState("");

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    const localStorageAuthData = ls.get("authData");
    if (localStorageAuthData == null) {
      // dont do anything, they are unauth
    } else {
      const providerType = localStorageAuthData.providerType;
      if (providerType === "amazon") {
        setEmail(localStorageAuthData.email);
      } else if (providerType === "google") {
        setEmail(localStorageAuthData.email);
      }
    }

    const organizationid = ls.get("organizationid");
    setCurrentOrganizationId(organizationid);
  }

  function signOut() {
    const localStorageAuthData = ls.get("authData");
    ls.set("authData", null);
    ls.set("organizationid", null);
    if (localStorageAuthData.providerType === "amazon") {
      Auth.signOut()
        .then(data => {
          //
          window.location.reload();
        })
        .catch(err => {
          console.log(err);
        });
    } else if (localStorageAuthData.providerType === "google") {
      // handled by Google Sign Out Button, should be an impossible case
    }
  }
  var pictureURL = "";

  const localStorageAuthData = ls.get("authData");
  if (localStorageAuthData == null) {
    // dont do anything, they are unauth
  } else {
    const providerType = localStorageAuthData.providerType;
    if (providerType === "amazon") {
    } else if (providerType === "google") {
      pictureURL = localStorageAuthData.picture;
    }
  }

  function googleLogoutSuccess() {
    ls.set("authData", null);
    ls.set("organizationid", null);
    window.location.reload();
  }

  function googleLogoutFailure(error) {
    console.log(error);
  }

  function googleSignOut() {
    const localStorageAuthData = ls.get("authData");
    var show = true;
    if (localStorageAuthData == null) {
      show = false;
    }
    else if (localStorageAuthData.providerType !== "google") {
      show = false;
    }

    return (
      show && (
        <GoogleLogout
          clientId="530469725356-el74ba1asc3g11dpc06ggn71skj4pq9c.apps.googleusercontent.com"
          buttonText="Logout"
          onLogoutSuccess={googleLogoutSuccess}
          onFailure={googleLogoutFailure}
        ></GoogleLogout>
      )
    );
  }

  function awsSignOut() {
    const localStorageAuthData = ls.get("authData");
    var show = true;
    if (localStorageAuthData == null) {
      show = false;
    }
    else if (localStorageAuthData.providerType !== "amazon") {
      show = false;
    }

    return (
      show && (
        <Button variant="secondary" onClick={signOut}>
          Logout
        </Button>
      )
    );
  }

  return (
    <Modal
      show={props.visible}
      onHide={props.onCancel}
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Account</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img
          className="avatar"
          src={pictureURL}
          alt="user avatar"
          style={{
            width: "100px",
            height: "100px",
            margin: "0",
            marginBottom: "15px"
          }}
        />
        <p>
          <span className="label">Email:</span> {email}
        </p>

        <p>
          {" "}
          <span className="label">Organization:</span> {currentOrganizationId}
        </p>
      </Modal.Body>
      <Modal.Footer>{googleSignOut()}</Modal.Footer>
    </Modal>
  );
}
